import React from 'react';

import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';

interface FixitToolPluginContainerProps {
  operationsSelected: Operation[]
}

interface FixitToolProps {
  operationSelected: Operation;
}

// Runtime dependency
const FixitToolPlugin: React.FC<FixitToolProps> = React.lazy(() => importFromS3('fixit-tool'));

export const FixitToolPluginContainer: React.FC<FixitToolPluginContainerProps> = ({ operationsSelected }: FixitToolPluginContainerProps) => {
  const { isLoading, operation } = useImpersonatedOperation();
  const operationSelected = operation || operationsSelected[0];

  // prevent rendering Fixit Tool if we're fetching operations
  if (isLoading || !operationSelected?.operationOwnerId) return null;

  return (
    <FixitToolPlugin
      operationSelected={operationSelected}
    />
  );
};
